import { render, staticRenderFns } from "./SimControlMainDashboard.vue?vue&type=template&id=1185d9a0"
import script from "./SimControlMainDashboard.vue?vue&type=script&lang=js"
export * from "./SimControlMainDashboard.vue?vue&type=script&lang=js"
import style0 from "./SimControlMainDashboard.vue?vue&type=style&index=0&id=1185d9a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports